import React from 'react';

import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';

import { isTaxLineItem, extractTaxPercentage } from './LineItemTaxWithheldMaybe';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Renders tax line item(s) for the customer breakdown as a positive amount.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - Customer-filtered line items
 * @param {boolean} props.isCustomer
 * @param {intlShape} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemTaxMaybe = props => {
    const { lineItems, isCustomer, intl } = props;

    if (!isCustomer) return null;

    const taxLineItems = (lineItems || []).filter(
        item => isTaxLineItem(item) && !item.reversal
    );

    if (taxLineItems.length === 0) return null;

    return (
        <>
            {taxLineItems.map((item, i) => {
                const percentage = extractTaxPercentage(item.code);
                const percentageLabel = percentage != null ? ` (${percentage}%)` : '';

                const absAmount =
                    item.lineTotal instanceof Money
                        ? new Money(Math.abs(item.lineTotal.amount), item.lineTotal.currency)
                        : null;
                const formattedAmount = absAmount ? formatMoney(intl, absAmount) : null;

                return (
                    <div key={`tax-customer-${i}`} className={css.lineItem}>
                        <span className={css.itemLabel}>{`Tax${percentageLabel}`}</span>
                        <span className={css.itemValue}>{formattedAmount}</span>
                    </div>
                );
            })}
        </>
    );
};

export default LineItemTaxMaybe;
